// src/pages/DriverMap.js
import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";

const RoutingMachine = ({ driverPos, passengerPos, destinationPos }) => {
  const map = useMap();
  const routingControlRef = useRef(null);

  useEffect(() => {
    if (!driverPos || !passengerPos || !destinationPos) return;

    if (!routingControlRef.current) {
      routingControlRef.current = L.Routing.control({
        waypoints: [
          L.latLng(driverPos[0], driverPos[1]),
          L.latLng(passengerPos[0], passengerPos[1]),
          L.latLng(destinationPos[0], destinationPos[1]),
        ],

        lineOptions: {
          styles: [{ color: "blue", weight: 5 }],
        },

        addWaypoints: false,
        draggableWaypoints: false,
        fitSelectedRoutes: true,

        // ✅ HIDE INSTRUCTION PANEL
        show: false,
        itinerary: false,

        // ✅ REMOVE DEFAULT MARKERS
        createMarker: () => null,
      }).addTo(map);

      // ✅ EXTRA SAFETY — REMOVE CONTAINER IF CREATED
      routingControlRef.current.on("routesfound", function () {
        const container =
          routingControlRef.current.getContainer();
        if (container) {
          container.style.display = "none";
        }
      });
    } else {
      routingControlRef.current.setWaypoints([
        L.latLng(driverPos[0], driverPos[1]),
        L.latLng(passengerPos[0], passengerPos[1]),
        L.latLng(destinationPos[0], destinationPos[1]),
      ]);
    }
  }, [driverPos, passengerPos, destinationPos, map]);

  return null;
};

export default RoutingMachine;
